module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/black-0.2-e04e7c95e6e7461a460a8cb328a2da86.png";